import { render, staticRenderFns } from "./detai.vue?vue&type=template&id=0adc46d9&scoped=true&"
import script from "./detai.vue?vue&type=script&lang=js&"
export * from "./detai.vue?vue&type=script&lang=js&"
import style0 from "./detai.vue?vue&type=style&index=0&id=0adc46d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc46d9",
  null
  
)

export default component.exports